import React, { useMemo, useEffect } from 'react';
import classnames from "classnames";
import Styles from "../../styles.module.scss";
import Headline4 from "../../../../components/headings/Headline4";
import FromHead from "../../../../components/headings/FromHead";
import { DropDownInput } from '../../../../wrappers/selectInput';
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from 'yup';
import { useForm } from "react-hook-form";
import * as CONSTANTS from '../../../../utils/CONSTANTS'
import { useState } from 'react';
import { Error } from "@progress/kendo-react-labels";
import { FormInput } from '../../../../wrappers/formInput';
import Button from '../../../../components/button';
import { RadioInput } from '../../../../wrappers/radioInput';
import mixpanelData from '../../../../utils/mixpanel';
import RadioButton from '../../../../components/radio';
import { MultiDropDownInput } from '../../../../wrappers/multiselectInput';
import { Icon } from "@iconify/react";
import PlacesAutocomplete, {
  geocodeByAddress,
} from 'react-places-autocomplete';
import { inWords } from '../../../../utils/EllowUtils';
import * as Utils from '../../../../utils/EllowUtils'


export type PreferenceDetailsFormFields = {
    // salaryPreference: number;
    expectedPay: string;
    timeBasis: string;
    currencyType: string;
    locationPreference: any;
    companyType:number;
    location:string;
    timeZone:any;
};

interface Props {
    ClickHandler: (event: any) => void
    defaultValues:{companyType?: number ; 
      timeZone?:string[];
      salary: {billingType: string; currencyType:string; expectedPay:string};
      locationPreference: {remoteType: number | undefined; location: {id:string; name:string}[]} },
    loginId?: string | null
}


const validationSchema = Yup.object({
    expectedPay: Yup.string()
      .required("Field is required"),
    timeBasis: Yup.string()
      .required("Field is required"),
    currencyType: Yup.string()
      .required("Field is required"),
    // companyType: Yup.number()
    //   .required("Field is required"),   
    
  })
    

  const Preference: React.FC<Props> = ({
    ClickHandler,
    defaultValues
  }) => {

    const formOptions = {
      resolver:yupResolver(validationSchema),
       defaultValues: useMemo(() => {
          return defaultValues;
        }, [defaultValues])
  }


  const {
      register,
      handleSubmit,
      control,
      reset,
      setValue,
      formState: { errors },
  }  = useForm< PreferenceDetailsFormFields>(formOptions);
  
  const email = localStorage.getItem('Email')
  const loginId = localStorage.getItem('loginId')
  const [locationPreference, setlocationPreference] = useState<number>()
  const [company, setCompany] = useState<any>()
  const [error, setError] = useState<string>('')
  const [radioError, setRadioError] = useState<string>('')
  const [flag1, setFlag1] = useState<boolean>(false)
  const [flag, setFlag] = useState<boolean>(false)
  const [payValue, setPayValue] = useState<string>('')
  const { v4: uuidv4 } = require('uuid');
  const [address, setAddress] = useState('')
  const [locationArray, setLocationArray] = useState<{id:string, name:string}[]>([])
  const [rateInWords, setRateInWords] = useState<string>()

  useEffect(() => {
    if(defaultValues.salary && typeof(defaultValues.timeZone) === 'object'){       
      setlocationPreference(defaultValues.locationPreference.remoteType)  
      setPayValue(defaultValues.salary.expectedPay)
      if(defaultValues.salary.expectedPay){
        setRateInWords(inWords(defaultValues.salary.expectedPay))
        setTimeout(() => {
          setRateInWords('')
        }, 4000);
      }
      if(defaultValues.locationPreference.remoteType === 1 ){
        setFlag(true)
      }
      if( defaultValues.locationPreference.remoteType === 2){
        setFlag1(true)   
      }
      let defaultData = {
        companyType:defaultValues.companyType,
        expectedPay: defaultValues.salary.expectedPay,
        timeBasis: defaultValues.salary.billingType ,
        currencyType: defaultValues.salary.currencyType,
        timeZone: defaultValues.timeZone 
      }
       reset(defaultData)
    }
    if (defaultValues && defaultValues.locationPreference) {
      setLocationArray(defaultValues.locationPreference.location)
    }
    
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  
  
  
  
  const handleChange = (e: any, name: string) =>{
       
    if( name === 'expectedPay'){
      let words = inWords(e.target.value)
      setRateInWords(words)
      setTimeout(() => {
        setRateInWords('')
      }, 4000);
      setPayValue(e.target.value ? Math.abs(e.target.value).toString() : '')
    }
    if(name === 'companyType'){
      setCompany(e.value)
      setRadioError('')
      setValue('companyType', e.value)

    }

    if( name === 'remoteOnly'){
      setFlag1(false)
      setFlag(false)
      setlocationPreference(0)
      setLocationArray([])
      setError('')
    }
    if(name ==='locationOnly'){
      delete errors.locationPreference
      setFlag(true)  
      setFlag1(false)   
      setLocationArray([]) 
      setlocationPreference(1)
      setError('')
    }
      if ( name === 'both'){
      delete errors.locationPreference
      setFlag1(true)  
      setLocationArray([])
      setFlag(false)    
      setlocationPreference(2)
      setValue('locationPreference', e.value)
      setError('')
    }
  }
    
  
  
  const onSubmitForm = (data:any) => {
    
    let hasError: boolean = false;
    if(data.companyType === 0){
      setRadioError('Field is required')
       hasError = true
    }
    if (locationPreference){
      if( locationPreference === 1 || locationPreference === 2){
        if (!locationArray || locationArray.length === 0){
          hasError = true
          setError('Field is required')
        }
      }
    }else if(locationPreference !== 0){
      hasError = true
      setError('Field is required')
    }

    
    if ( !hasError ){
      let value =
      {
        preference :{
          salary : {
            currencyType:data.currencyType,
            expectedPay:data.expectedPay,
            billingType:data.timeBasis
                 },
        locationPreference: {
            remoteType: locationPreference,
            location: locationPreference ===  1 || locationPreference ===  2 ? locationArray : []
        } ,
        companyType: data.companyType,
        timeZone:data.timeZone
        }
      }
      if(value.preference.timeZone === ''){
        delete value.preference.timeZone
      }   
      if(value) {
        mixpanelData('MWP-Preferance Updated', {
          'salary': value.preference.salary.expectedPay + ' ' + value.preference.salary.currencyType + ' ' + value.preference.salary.billingType,
          'TimeZone' : value.preference.timeZone.toString(),
          'Company type' : value.preference.companyType && Utils.checkCompanyType(value.preference.companyType),
          'LocationPreference' : value.preference.locationPreference && Utils.checkLocationPreference(value.preference.locationPreference.remoteType)
        })
        mixpanelData('New MWP - Preferance update', {
          'distinct_id':  email,
          'Candidate loginid' : loginId,
          'Expected salary': value.preference.salary.expectedPay + ' ' + value.preference.salary.currencyType + '/' + value.preference.salary.billingType,
          'Time zone' : value.preference.timeZone,
          'Company type' : value.preference.companyType && Utils.checkCompanyType(value.preference.companyType),
          'Location preference' : value.preference.locationPreference && Utils.checkLocationPreference(value.preference.locationPreference.remoteType),
          'Location array': value.preference.locationPreference && value.preference.locationPreference.location.length > 0 ? value.preference.locationPreference.location.map((item: any) => {return(item.name)}) : 'Not mentioned'
        })
      }
      window.scrollTo(0, 0);
      ClickHandler(value)  
    }
  }

  const handleSelect = async (value: any) => {

    const results = await geocodeByAddress(value);
    let data = {
      "id": uuidv4(),
      "name": results[0].formatted_address
    }    
    setLocationArray([...locationArray, data])
    setAddress('')
    setError('')
  }

  const removeLocation = (item: any) => {
    const index = locationArray.findIndex(findItem => findItem.id === item.id); 
    locationArray.splice(index, 1);
    setLocationArray([...locationArray])
  }


  return (
    <form>
      <section className={Styles.preferencesWrap}>
      <Headline4>Preferences</Headline4>
  
      <FromHead>Expected Pay*</FromHead>
     <div className="pay-exp-wrap">
          <div className="form-group">
            <label className="lablel">I expect</label>
            <FormInput<PreferenceDetailsFormFields>
                id='expectedPay'
                name='expectedPay'
                type='number'
                value={payValue}
                placeholder="Enter Amount"
                register={register}
                errors={errors}
                onchange={(e:any) => handleChange(e,'expectedPay')}
            />      
          </div>
            <div className={classnames(Styles.currencyFiled, 'label-position')}>
              <DropDownInput< PreferenceDetailsFormFields>
                  data={CONSTANTS.currencyTypeList}
                  name="currencyType"
                  label='INR/USD'
                  control = {control}
                  register={register}
                  errors={errors}
              />
            </div>
            <div className="form-group form-per label-position">
            <label className="lablel">per</label>
            <DropDownInput< PreferenceDetailsFormFields>
                data={CONSTANTS.timeBasisList}
                name="timeBasis"
                label='HOUR/DAY/MONTH'
                control = {control}
                register={register}
                errors={errors}

            />
            </div>
        </div>
       {rateInWords} 
       <br></br>
       <br></br>
      <FromHead>Location preference*</FromHead>
      <div className="mb-40">
         <div className="form-group">
           <RadioButton
               name="locationPreference"
               label="Remote Only" 
               value={1} 
               defaultChecked={false}
               handleChange={(e: any) => handleChange(e, 'remoteOnly')} 
               checked={locationPreference === 0 }
            />
             </div>
             <div className="form-group">
              <RadioButton
                  name="locationPreference"
                  label="Onsite Only" 
                  value={2} 
                  defaultChecked={false}
                  handleChange={(e: any) => handleChange(e, 'locationOnly')} 
                  checked={ locationPreference === 1}
                />
             </div>
             
          <div className={Styles.tagListGroup}>
             {flag && locationArray && locationArray.map((item) => {
               return (
                <div className={Styles.tagListItem}>
                  {item.name} <Icon icon="eva:close-outline" onClick={() => removeLocation(item)}/>
                </div>
               )
             })}
             </div>

           <div className='preference-form-wrapper'>
           <div className="form-group">
                {flag && <PlacesAutocomplete
                  value={address}
                  onChange={setAddress}
                  onSelect={handleSelect}
                >
                  {({getInputProps, suggestions, getSuggestionItemProps, loading}) => (
                    <div className="search-filed">
                      <Icon icon="carbon:search"/>
                      <input 
                          {...getInputProps({
                            placeholder: 'Search Places ...',
                            className: 'location-search-input field',
                          })}
                        />
                        { suggestions && suggestions.length > 0 && <div  className="suggestion-list">
                          { loading ? <div className="suggestion-item">...loading</div> : null }
                          {suggestions.map(suggestion => {
                            return (
                              <div {...getSuggestionItemProps(suggestion)} className="suggestion-item">
                                {suggestion.description}
                              </div>
                            );
                          })}
                        </div>}
                    </div>
                  )}

                </PlacesAutocomplete>}
            </div>
            </div>
             <div className="form-group">
              <RadioButton
                  name="locationPreference"
                  label="Remote and Onsite" 
                  value={3} 
                  defaultChecked={false}
                  handleChange={(e: any) => handleChange(e, 'both')} 
                  checked={ locationPreference === 2}
                />
             </div>

          <div className={Styles.tagListGroup}>
             {flag1 && locationArray && locationArray.map((item) => {
               return (
                <div className={Styles.tagListItem}>
                  {item.name} <Icon icon="eva:close-outline" onClick={() => removeLocation(item)}/>
                </div>
               )
             })}
             </div>

           <div className='preference-form-wrapper'>
           <div className="form-group">
                {flag1 && <PlacesAutocomplete
                  value={address}
                  onChange={setAddress}
                  onSelect={handleSelect}
                >
                  {({getInputProps, suggestions, getSuggestionItemProps, loading}) => (
                    <div className="search-filed">
                      <Icon icon="carbon:search"/>
                      <input 
                          {...getInputProps({
                            placeholder: 'Search Places ...',
                            className: 'location-search-input field',
                          })}
                        />
                        { suggestions && suggestions.length > 0 && <div  className="suggestion-list">
                          { loading ? <div className="suggestion-item">...loading</div> : null }
                          {suggestions.map(suggestion => {
                            return (
                              <div {...getSuggestionItemProps(suggestion)} className="suggestion-item">
                                {suggestion.description}
                              </div>
                            );
                          })}
                        </div>}
                    </div>
                  )}

                </PlacesAutocomplete>}
            </div>
            </div>
            <Error>{error}</Error>
        </div>
      <FromHead>Preferred type of the company* </FromHead>
      <div className="mb-40">
      <div className="preference-form-wrapper">
            <RadioInput<PreferenceDetailsFormFields>
              data = {CONSTANTS.companyType}
              name="companyType"
              handleChange={(e: any) => handleChange(e, 'companyType')}
              register={register}
              layout='vertical'
              errors={errors}
              control={control}
              checked={company}
            />
      </div>
      <Error>{radioError}</Error>
      </div>

      <FromHead>Preferred Time Zone </FromHead>
      <div className="mb-40 preference-form-wrapper">
            <MultiDropDownInput<PreferenceDetailsFormFields>
              data = {CONSTANTS.timeZone}
              name="timeZone"
              // handleChange={(e: any) => handleChange(e, 'timeZone')}
              // checked={locationPreference}
              register={register}
              placeholder='Search Time Zones Here'
              errors={errors}
              control={control}
              disabled={false}
            />
      </div>
    
      
      <Button onClick={handleSubmit(onSubmitForm)} variant="primary">Save</Button>
    </section>
    </form>
  );
}
export default Preference;
